import { twMerge } from "tailwind-merge";
import { forwardRef } from "react";
import { TableHeadBase, type TableHeadBaseProps } from "@core/ui";
import { Type } from "@themes/pollinator/ui/Type";

export type Props = Omit<TableHeadBaseProps, "data-testid">;

/**
 * Styled table head cell wrapping TableHeadBase.
 */
export const TableHead = forwardRef<HTMLTableCellElement, Props>(
  ({ children, className, ...props }, ref) => {
    return (
      <TableHeadBase
        ref={ref}
        className={twMerge(
          "py-2 px-4 text-left align-middle text-brand-800",
          className
        )}
        data-testid="table-head"
        {...props}
      >
        <Type variant="h6" as="span">{children}</Type>
      </TableHeadBase>
    );
  }
);

TableHead.displayName = "TableHead";

export default TableHead;

